<article>
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <header (click)="openDialog()" data-id="title">
    <div>{{ title }}</div>
    <button mat-icon-button data-testid="wheelEdit" >
      <mat-icon>mode_edit</mat-icon>
    </button>
  </header>

  <div [class.disabled]="disabled">
    <div class="ng-data-picker flex-box">

      <!-- picker-group-layer -->
      @for (group of data; track group; let gIndex = $index) {
        <div #pickerGroupLayer
          [ngClass]="getGroupClass(gIndex)"
          class="picker-group" >
          <div class="picker-list">
            @for (item of group.list; track item; let iIndex = $index) {
              @if (group.divider) {
                <div
                  class="picker-item divider"
                  [ngClass]="getItemClass(gIndex, iIndex, true)">
                </div>
              } @else {
                <div
                  class="picker-item" [ngClass]="getItemClass(gIndex, iIndex)" [ngStyle]="getItemStyle(gIndex, iIndex)">
                  @if (homeTeamName && awayTeamName) {
                    <span
                    class="wheel-team">{{ getTeamName(iIndex) }}</span>
                  }
                  <span class="wheel-value">{{ item.valueOf() || item }}</span>
                </div>
              }
            }
          </div>
        </div>
      }

      <div #pickerHandleLayer class="picker-handle-layer flex-box dir-column"
        (keydown)="onKeydown($event)"
        (click)="focusPicker()"
        tabindex="0">
        <div data-type="top" class="picker-top weight-1"
          (dblclick)="openDialog()"
          title="{{ 'components.wheelSelector.tooltipDecrease' | transloco }}"
        ></div>
        <div data-type="middle" class="picker-middle"
          (dblclick)="openDialog()"
        title="{{ 'components.wheelSelector.tooltipDblclick' | transloco }}"></div>
        <div data-type="bottom" class="picker-bottom weight-1"
          (dblclick)="openDialog()"
        title="{{ 'components.wheelSelector.tooltipIncrease' | transloco }}"></div>
      </div>

    </div>
  </div>
</article>
